// Aspiration grid validation. Mirrors the backend (aspirations.item schema):
// donor_id required, total/viables integers ≥ 0, viables ≤ total. Plus: no
// duplicate donor in a session, and no orphan (partially-filled) rows.

// A row the user never touched — dropped on save, not an error.
export function isEmptyRow(r) {
    return !r.donor && r.total === '' && r.viables === '' && !(r.notes && r.notes.trim());
}

// Returns the viability rate %, or null when the row's numbers aren't a valid
// basis (non-integer, negative, viables > total, or no total) — so the badge
// never shows a misleading figure that contradicts validation.
export function rowRate(r) {
    const total = Number(r.total);
    const viables = Number(r.viables);
    if (!total || !Number.isInteger(total) || !Number.isInteger(viables)) return null;
    if (viables < 0 || viables > total) return null;
    return Math.round((viables / total) * 100);
}

export function validateAspirations(rows) {
    const rowErrors = {};
    const seen = new Set();
    const considered = rows.filter(r => !isEmptyRow(r));

    considered.forEach((r) => {
        const e = {};

        if (!r.donor) e.donor = 'Elegí una vaca.';
        else if (seen.has(r.donor.id)) e.donor = 'Vaca repetida en la sesión.';
        else seen.add(r.donor.id);

        const total = Number(r.total);
        const viables = Number(r.viables);

        if (r.total === '' || !Number.isInteger(total) || total < 0) e.total = 'Total inválido.';
        if (r.viables === '' || !Number.isInteger(viables) || viables < 0) e.viables = 'Viables inválido.';
        if (!e.total && !e.viables && viables > total) e.viables = 'No puede superar el total.';

        if (Object.keys(e).length) rowErrors[r.key] = e;
    });

    const valid = considered.length > 0 && Object.keys(rowErrors).length === 0;
    return { rowErrors, valid, considered };
}
